import { useRef } from 'react';

/**
 * Handles maintaining a list of pending promises.
 * Source: https://medium.com/trabe/prevent-click-events-on-double-click-with-react-with-and-without-hooks-6bf3697abc40
 */
export const useCancellablePromises = () => {
  const pendingPromises = useRef([]);

  const appendPendingPromise = (promise) => {
    pendingPromises.current = [...pendingPromises.current, promise];
  };

  const removePendingPromise = (promise) =>
    (pendingPromises.current = pendingPromises.current.filter(
      (pendingPromise) => pendingPromise !== promise,
    ));

  const clearPendingPromises = () =>
    pendingPromises.current.map((pendingPromise) => pendingPromise.cancel());

  const api = {
    appendPendingPromise,
    removePendingPromise,
    clearPendingPromises,
  };

  return api;
};
